import React, { useContext } from "react";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import { MapContext } from "contexts/MapContext";

const Reset = ({}) => {
  const {
    advancedOptions,
    setAdvancedOptions,
    featureList,
    setFilteredFeatureList,
  } = useContext(MapContext);
  const useStyles = makeStyles((theme) => ({
    formControl: {
      marginRight: theme.spacing(1),
      backgroundColor: "#ffffff",
      borderRadius: "5px",
      color: "#4D4D4D",
      letterSpacing: "2px",
      "&:hover": {
        background: "#e6e6e6",
      },
      whiteSpace: "nowrap",
    },
    chips: {
      display: "flex",
      flexWrap: "wrap",
    },
    typography: {
      padding: theme.spacing(2),
    },
    root: {
      color: "#4D4D4D",
    },
    popoverPaper: {
      backgroundColor: "#ffffff",
    },
  }));

  const classes = useStyles();

  const handleClick = () => {
    setAdvancedOptions({});
    setFilteredFeatureList(featureList);
  };

  return (
    <Button
      aria-describedby={"Reset Filters"}
      variant="contained"
      onClick={handleClick}
      className={classes.formControl}
    >
      Reset
    </Button>
  );
};

export default Reset;
